<template>
  <div class="geofence-list-wrapper">
    <div v-if="loading"
        class="circular-loader">
      <base-circular-loader color="primary"
                            size="medium" />
    </div>

    <VuePerfectScrollbar v-if="!loading && namedLocations.length" class="geofence-list">
      <geofence-list-item v-for="location in namedLocations"
                          :named-location="location"
                          :key="location.id"
                          @click="openGeofenceItem(location.id)" />
    </VuePerfectScrollbar>

    <geofence-empty-screen v-else @close="$emit('close')" />
  </div>
</template>

<script>
  import GeofenceListItem from '@/components/Common/Geofence/GeofenceListItem'
  import GeofenceEmptyScreen from '@/components/Common/Geofence/GeofenceEmptyScreen'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    components: {
      GeofenceListItem,
      GeofenceEmptyScreen,
      VuePerfectScrollbar
    },

    data() {
      return {
        loading: false
      }
    },

    created() {
      this.getNamedLocations()
    },

    methods: {
      async getNamedLocations() {
        this.loading = true

        await this.$store.dispatch('geofence/loadNamedLocations', this.groupId)

        this.loading = false
      },

      openGeofenceItem(id) {
        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'configure-location',
            params: {
              mode: 'update',
              locationId: id
            }
          })

          return
        }

        this.showModal('geofence-configure', {
          mode: 'update',
          id
        })
      }
    },

    computed: {
      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      ...mapGetters('geofence', {
        namedLocations: 'getNamedLocations'
      }),

      groupId() {
        return this.currentUser.group_id
      }
    }
  }
</script>

<style lang="scss" scoped>
  .circular-loader {
    width: 100%;
    height: 100%;
    min-height: 400px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .geofence-list {
    height: 100%;
    min-height: 400px;
    position: relative;
  }
</style>